import { useState, useEffect, useCallback } from 'react'
import { UrlParamTypes } from '@dxp-module/common'

const useUrlSearchParams = () => {
  const queryString = window.location.search
  const getUrlSearchParams = useCallback(() => {
    const searchParams = new URLSearchParams(queryString)

    return {
      [UrlParamTypes.TOKEN]: searchParams.get(UrlParamTypes.TOKEN) || '',
      [UrlParamTypes.TARGET]: searchParams.get(UrlParamTypes.TARGET) || '',
      [UrlParamTypes.RESET_TOKEN]:
        searchParams.get(UrlParamTypes.RESET_TOKEN) || '',
      [UrlParamTypes.DXP_PREVIEW]:
        searchParams.get(UrlParamTypes.DXP_PREVIEW) || '',
    }
  }, [queryString])
  const [searchParams, setSearchParams] = useState<
    Partial<Record<UrlParamTypes, string>>
  >(getUrlSearchParams())

  useEffect(() => {
    setSearchParams(prev => ({
      ...prev,
      ...getUrlSearchParams(),
    }))
  }, [getUrlSearchParams])

  return searchParams
}

export default useUrlSearchParams
